/**
 * Created by fers on 05.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage, IntlShape} from 'react-intl';

interface NotFoundProps {
    intl: IntlShape;
    location: object;
}

class NotFound extends React.Component<NotFoundProps> {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
    };


    static contextTypes = {
        router: PropTypes.object
    };

    render() {
        return (
            <div className="NotFound">
                <h1> <FormattedMessage defaultMessage="Not found" id="notFound.title" /></h1>
                <small style={{color: 'grey'}}>{this.props.location.pathname}</small>
            </div>
        );
    }
}

export default injectIntl(NotFound);
